import '../css/www.css';
import Alpine from 'alpinejs';
import { animate, stagger, inView } from 'motion';

window.Alpine = Alpine;
Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches;
  const hasSeenIntro = sessionStorage.getItem('www-intro-seen');

  // Hero: staggered intro on first visit
  const heroElements = document.querySelectorAll('[data-animate="hero"]');
  if (heroElements.length > 0) {
    if (prefersReducedMotion || hasSeenIntro) {
      heroElements.forEach((el) => {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
    } else {
      animate(
        heroElements,
        { opacity: [0, 1], transform: ['translateY(20px)', 'translateY(0)'] },
        {
          duration: 0.7,
          delay: stagger(0.12, { start: 0.1 }),
          easing: [0.23, 1, 0.32, 1],
        },
      );
      sessionStorage.setItem('www-intro-seen', 'true');
    }
  }

  // Sections: inView reveal
  if (!prefersReducedMotion) {
    const sections = document.querySelectorAll('[data-animate="section"]');
    sections.forEach((section) => {
      inView(
        section,
        () => {
          const items = section.querySelectorAll('[data-animate="item"]');
          if (items.length > 0) {
            animate(
              items,
              {
                opacity: [0, 1],
                transform: ['translateY(12px)', 'translateY(0)'],
              },
              {
                duration: 0.5,
                delay: stagger(0.08, { start: 0.05 }),
                easing: [0.23, 1, 0.32, 1],
              },
            );
          } else {
            animate(
              section,
              {
                opacity: [0, 1],
                transform: ['translateY(12px)', 'translateY(0)'],
              },
              { duration: 0.5, easing: [0.23, 1, 0.32, 1] },
            );
          }
        },
        { amount: 0.15 },
      );
    });
  } else {
    document
      .querySelectorAll('[data-animate="section"], [data-animate="item"]')
      .forEach((el) => {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
  }

  // Mobile nav
  const mobileToggle = document.getElementById('mobile-nav-toggle');
  const mobileClose = document.getElementById('mobile-nav-close');
  const mobileOverlay = document.getElementById('mobile-nav-overlay');
  const mobilePanel = document.getElementById('mobile-nav-panel');

  function openMobileNav() {
    if (!mobileOverlay || !mobilePanel) return;
    mobileOverlay.classList.remove('hidden');
    requestAnimationFrame(() => {
      mobileOverlay.classList.add('is-open');
      mobilePanel.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileOverlay || !mobilePanel) return;
    mobileOverlay.classList.remove('is-open');
    mobilePanel.classList.remove('is-open');
    document.body.style.overflow = '';
    const onEnd = () => {
      mobileOverlay.classList.add('hidden');
      mobileOverlay.removeEventListener('transitionend', onEnd);
    };
    mobileOverlay.addEventListener('transitionend', onEnd);
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileNav);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
  if (mobileOverlay)
    mobileOverlay.addEventListener('click', (e) => {
      if (e.target === mobileOverlay) closeMobileNav();
    });

  document.addEventListener('keydown', (e) => {
    if (
      e.key === 'Escape' &&
      mobileOverlay &&
      !mobileOverlay.classList.contains('hidden')
    ) {
      closeMobileNav();
    }
  });

  // Nav: scroll-based background
  const nav = document.getElementById('www-nav');
  if (nav) {
    const updateNav = () => {
      if (window.scrollY > 20) {
        nav.style.backgroundColor = 'rgba(247, 247, 247, 0.9)';
        nav.style.borderBottom = '1px solid rgba(0, 0, 0, 0.08)';
      } else {
        nav.style.backgroundColor = 'transparent';
        nav.style.borderBottom = '1px solid transparent';
      }
    };
    updateNav();
    window.addEventListener('scroll', updateNav, { passive: true });
  }
});
